module.exports = require('./helpers/bundle-url').getBundleURL('8mUD3') + "logo-dark.eefe0b7f.svg";